import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

//Components
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { NotificationManager } from 'Components/Notifications';
import { Button } from '@gpstrackit/gtc-react-controls';

//Actions
import { closeWarningConfirmResolveModal, resolveMaintenanceWarningEvents, reset } from './redux/slice';
import { closeWarningResolveModal } from 'Redux/actions';

const ConfirmResolve = (props) => {

    const dispatch = useDispatch(0)
    const { messages } = useIntl();

    //Redux States
    const { open, loading, data, error, result } = useSelector(state => state.warningsConfirmResolveRedux);

    const handleClose = () => {
        dispatch(closeWarningConfirmResolveModal())
    }

    const applyChanges = () => {
        let warningCodes = data?.warnings
        dispatch(resolveMaintenanceWarningEvents({ ...data, warnings: warningCodes }))
    }

    useEffect(() => {
        if (result) {
            let title = data?.bulk ? messages['warnings_main_resolve_all_warnings'] : data?.warnings?.length === 1 ? messages['warnings_main_resolve_warning'] : messages['warnings_main_resolve_warnings']
            let successMessage = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_success_message_resolved_all'] : messages['warnings_main_success_message_resolved']
            let errorMessage = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_error_message_resolved_all'] : messages['warnings_main_error_message_resolved']
            if (result?.resolve) {
                NotificationManager.success(successMessage, title, 3000);
                dispatch(closeWarningResolveModal())
                handleClose()
            } else {
                NotificationManager.error(errorMessage, title, 3000);
                dispatch(reset({ result: null }))
            }
        }
    }, [result])

    useEffect(() => {
        if (error) {
            let title = data?.bulk ? messages['warnings_main_resolve_all_warnings'] : data?.warnings?.length === 1 ? messages['warnings_main_resolve_warning'] : messages['warnings_main_resolve_warnings']
            let errorMessage = (data?.bulk || data?.warnings?.length > 1) ? messages['warnings_main_error_message_resolved_all'] : messages['warnings_main_error_message_resolved']
            NotificationManager.error(errorMessage, title, 3000);
            dispatch(reset({ error: false }))
        }
    }, [error])

    return (
        <Modal
            title={data?.bulk ? messages['warnings_main_resolve_all_warnings'] : data?.warnings?.length === 1 ? `${messages['warnings_main_resolve_warning']} (${messages[`warnings_main_${data?.warnings[0]}`] || data?.warnings[0]})` : messages['warnings_main_resolve_warnings']}
            position="right"
            size="small"
            open={open}
            loading={loading}
            handleClose={() => handleClose()}
        >
            <ModalBody>
                <div style={{ overflow: 'hidden', padding: '0 25px' }}>
                    {
                        data?.bulk ? <p>{messages['warnings_main_message_resolved_all']}</p> : data?.warnings?.length === 1 ? <p>{messages['warnings_main_message_resolved']}</p> : <p>{messages['warnings_main_message_resolved_selected']}</p>
                    }
                    <ul>
                        {
                            data?.warnings?.length > 1 && data?.warnings?.map((item, index) => {
                                return (
                                    <li key={index}>{messages[`warnings_main_${item}`] || item}</li>
                                )
                            })
                        }
                    </ul>
                </div>
            </ModalBody>
            <ModalFooter>
                <div style={{ marginLeft: 5 }}>
                    <Button
                        variant='secondary'
                        onClick={() => handleClose()}
                        style={{ marginRight: 5 }}
                    >
                        {messages['warnings_main_close']}
                    </Button>
                    <Button
                        variant='primary'
                        onClick={() => applyChanges()}
                    >
                        {messages['warnings_main_resolve']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmResolve;